import type { DocNode } from '@atlaskit/adf-schema/doc';
import type { JSONNode } from '@atlaskit/editor-json-transformer/types';

export type RemixDynamicUiContentType = 'page' | 'blogpost';

export type DynamicUiSource = {
	contentType: RemixDynamicUiContentType;
	startLocalId: string;
	endLocalId: string;
	startIndex: number;
	endIndex: number;
	fragmentAdf: JSONNode[] | null;
	fullAdf: DocNode;
};

export const resolveRemixDynamicUiContentType = (
	contentType: string | undefined,
): RemixDynamicUiContentType => (contentType === 'blogpost' ? 'blogpost' : 'page');
